import { gql } from '@apollo/client';

const UPDATE_STUDY_REFERRING_PHYSICIAN = gql`
  mutation UpdateStudyReferringPhysician($input: UpdateStudyReferringPhysicianInput!) {
    updateStudyReferringPhysician(input: $input) {
      message
      isSuccess
      study {
        info {
          referringPhysician {
            id
            firstName
            lastName
            contact {
              phone1
              nightPhone
              fax
              country
            }
            email
            npi
          }
        }
      }
    }
  }
`;

export default UPDATE_STUDY_REFERRING_PHYSICIAN;
